export class TeamModerator {
  firstname: string;
  internal: boolean;
  lastname: string;
  type: string;
  userid: string;
  username: string;

  public static hasTeamModerator(moderators: Array<TeamModerator>): boolean {
    if (moderators == null || moderators.length === 0) {
      return false;
    }
    const moderatorsWithoutAdminAndReporter = moderators.filter(moderator => {
      return moderator.internal != null && moderator.internal !== true
    });
    return moderatorsWithoutAdminAndReporter.length > 0;
  }
}
